export class CategoryForCourse {
  constructor() {}
  public id: number;
  public nameNl: string;
  public nameEn: string;
  public deleted: boolean = false;
}
